import app from 'flarum/common/app';
import Component from 'flarum/common/Component';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Button from 'flarum/common/components/Button';
import extractText from 'flarum/common/utils/extractText';
const t = (key, params) => app.translator.trans('ppk2-profile.lib.agreement.' + key, params);

/**
 * «Подтверждения игроков»: each player's acceptance list of «Пользовательское соглашение»
 * (ppk2_profiles.agreement_log). GET /api/ppk2/agreement/acceptances; admins and «Техподдержка».
 */
export default class AgreementAcceptances extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.q = '';
    this.rows = null;
    this.error = false;
    this.load();
  }
  load() {
    this.rows = null;
    this.error = false;
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/ppk2/agreement/acceptances',
      params: this.q ? {
        q: this.q
      } : {}
    }).then(r => this.rows = r.data || [], () => this.error = true).finally(() => m.redraw());
  }
  line(l) {
    const s = (key, params) => extractText(t(key, params));
    return l.replace(/edition (\d+) \(custom\)/, (x, n) => s('edition_n', {
      n
    }) + ' (' + s('mode_custom') + ')').replace(/edition (\d+)/, (x, n) => s('edition_n', {
      n
    })).replace(/ — (registration|accepted)$/, (x, via) => ' — ' + s('via_' + via));
  }
  view() {
    return m("div", {
      className: "Ppk2AccountLog Ppk2Acceptances"
    }, m("form", {
      className: "Ppk2AccountLog-search",
      onsubmit: e => {
        e.preventDefault();
        this.load();
      }
    }, m("input", {
      className: "FormControl",
      type: "search",
      placeholder: t('search_ph'),
      value: this.q,
      oninput: e => this.q = e.target.value
    }), m(Button, {
      className: "Button",
      type: "submit",
      icon: "fas fa-search"
    })), this.error ? m("p", {
      className: "helpText"
    }, "Error") : !this.rows ? m(LoadingIndicator, null) : !this.rows.length ? m("p", {
      className: "helpText"
    }, t('empty')) : m("div", {
      className: "Ppk2AccountLog-wrap"
    }, m("table", {
      className: "Ppk2AccountLog-table"
    }, m("thead", null, m("tr", null, ['c_user', 'c_nick', 'c_log', 'c_state'].map(k => m("th", null, t(k))))), m("tbody", null, this.rows.map(r => m("tr", {
      className: 'Ppk2Acceptances-row--' + (r.upToDate ? 'ok' : r.acceptedEdition ? 'old' : 'never')
    }, m("td", null, r.username), m("td", null, r.mainNick || '—'), m("td", {
      className: "Ppk2Acceptances-lines"
    }, r.lines.length ? r.lines.map(l => m("div", null, this.line(l))) : '—'), m("td", null, r.upToDate ? t('up_to_date') : r.acceptedEdition ? t('outdated') : t('never'))))))));
  }
}
flarum.reg.add('ppk2-profile', 'common/AgreementAcceptances', AgreementAcceptances);